import { useMemo } from "react";
import { effectiveProjects, nextMoveCount } from "./derived";
import { useUsageDemoState } from "./store";

/** How many open action items are on the user's side: the Pipeline's badge. */
export const useNextMovesCount = (): number => {
    const state = useUsageDemoState();
    return useMemo(() => nextMoveCount(effectiveProjects(state)), [state]);
};
